<template>
	<div class="dv">
		<el-table :data="tableData" stripe style="width: 100%" border>
			<el-table-column prop="invoiceInfo.resource" :label="$t('order.BillingType')" align="center">
			</el-table-column>
			<el-table-column prop="invoiceInfo.name" :label="$t('order.corporatename')" align="center">
			</el-table-column>
			<el-table-column prop="invoiceInfo.num" :label="$t('order.taxpayer')" align="center">
			</el-table-column>
			<el-table-column prop="invoiceInfo.city" :label="$t('order.address')" align="center">
			</el-table-column>
			<el-table-column prop="invoiceInfo.tel" :label="$t('order.tel')" align="center">
			</el-table-column>
			<el-table-column prop="invoiceInfo.kfhmc" :label="$t('order.OpeningName')" align="center">
			</el-table-column>
			<el-table-column prop="invoiceInfo.kfhzh" :label="$t('order.OpeningAccount')" align="center">
			</el-table-column>
			<el-table-column prop="invoiceInfo.seate" label="开票状态" align="center">
			</el-table-column>
			<el-table-column prop="invoiceLink" label="下载发票" align="center">
				<template slot-scope="scope" >
					<a :href="$img+scope.row.invoiceLink" download v-if="scope.row.invoiceLink">
						<el-button size="mini" type="primary"><i class="el-icon-bottom el-icon--right"></i></el-button>
					</a>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				tableData: []
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			getList() {
				this.$get('/api/invoice/list', {
					token: sessionStorage.getItem('token')
				}).then(res => {
					res.data.map(item => {
						item.invoiceInfo = JSON.parse(item.invoiceInfo)
						item.invoiceInfo.num = item.invoiceInfo.num ? item.invoiceInfo.num : '---'
						item.invoiceInfo.seate = item.examState == 1?'开票中':item.examState == 2?'开票成功':'拒绝开票'
						item.invoiceInfo.resource = item.invoiceType == 1 ? '国内开票' : '国外开票'
					})
					this.tableData = res.data
					console.log(res)
				})
			}
		},
	};
</script>
<style scoped>
	.dv{
		margin-left: 30px;
		margin-top: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/components/memberCenter/sub/Billing.vue